/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Leerlijn_Tikspelen2Inputs */

const nl_enums_leerlijn_tikspelen2 = /** @type {(inputs: Enums_Leerlijn_Tikspelen2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tikspelen`)
};

/**

* @param {Enums_Leerlijn_Tikspelen2Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_leerlijn_tikspelen2 = /** @type {((inputs?: Enums_Leerlijn_Tikspelen2Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Leerlijn_Tikspelen2Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_leerlijn_tikspelen2(inputs)
});
export { enums_leerlijn_tikspelen2 as "enums.Leerlijn.Tikspelen" }